<template>
  <div>
    <div class="fullpage-container" @wheel="handleWheel">
      <div 
        class="fullpage-wrapper" 
        :style="{ transform: `translateY(-${currentIndex * 100}vh)` }"
      >
        <!-- 第一屏 -->
        <section class="fullpage-section section-1" >
          <NeuralParticle />
          <div class="mask"></div>
          <div class="section-content_1" id="particle-container">
            <img class="topBT" src="@/assets/img/home/top_b.png" alt="">
            <div class="section-1_top">
              <div class="section-1_top_title">碳知 丨 用AI原生之力  探索双碳新纪元</div>
              <div class="section-1_top_desc">不止是更智能的AI工具,更是一次对未来的探索</div>
              <div class="section-1_top_btn">
                <div class="section-1_top_btn_item" @click="gotoWeb">立即体验</div>
              </div>
            </div>
            <div class="section-1_bottom">
              <img class="section-1_bottom_img" src="@/assets/img/home/section-1_bottom_img_server.png">
            </div>
          </div>
        </section>
        
        <!-- 第三屏 -->
        <section class="fullpage-section section-3">
          <div class="section-3-container" :class="{ 'scrollable': currentIndex === 1 }">
            <div class="section-3-content">
              <div class="section-3-content_1">
                <div class="section-3-content_1_view">
                  <div class="section-3-content_1_view_title">碳知 <span>Carbon Insight</span></div>
                  <div class="section-3-content_1_view_desc fontSize-48">双碳生态平台</div>
                  <!-- <img class="section-3-content_1_view_img" src="@/assets/img/home/section-3-content_1_view_img.png" alt=""> -->
                  <!-- <div class="section-3-content_1_view_desc fontSize-24">碳知，由此而生</div> -->
                  <div class="section-3-content_1_view_btn" @click="gotoWeb">前往体验</div>
                  <!-- <div class="section-3-content_1_view_text">依托自主研发的「碳芯」双碳垂直大模型与全量行业知识中枢，我们将资深专家的完整工作逻辑，系统性融入智能体系。<br>它不止是生成内容的工具，更是陪你走完从需求澄清、方案设计到落地执行的，全流程双碳智能伙伴。</div> -->
                </div>
              </div>
              <div class="section-3-content_1_dask">
                <div class="section-3-content_1_dask_view">
                  <div>不只是更快生成方案</div>
                  <div>而是重新组织双碳工作</div>
                  <div style="margin-top:50px">碳知先理解问题、确认边界、建立逻辑，</div>
                  <div style="margin-bottom:50px">再给出准确、可依据、可执行的方案交付。</div>
                  <div>这就是“双碳方案专家”的核心价值。</div>
                </div>
              </div>
              <div class="section-3-content_2">
                <div class="section-3-content_2_t">
                  <div class="section-3-content_2_t_view">
                    <div class="section-3-content_2_t_view_text1">你好，我是碳知</div>
                    <div class="section-3-content_2_t_view_text2">你的专属双碳AI伙伴</div>
                  </div>
                  <div class="section-3-content_2_t_view_content">
                    <div class="item" @click="scrollToItem(0)">
                      <div class="item_t item_t_1"></div>
                      <div class="item_view item_view_1">
                        <img class="item_view_img" src="@/assets/img/home/icon_1.png" alt="">
                      </div>
                      <div class="item_b">
                        <div class="item_b_text1">企业场景｜碳盘查服务</div>
                        <div class="item_b_text2">碳知AI助力企业从需求识别到报告生成，实现碳盘查全流程智能闭环落地</div>
                      </div>
                    </div>
                    <div class="item" @click="scrollToItem(1)">
                      <div class="item_t item_t_2"></div>
                      <div class="item_view item_view_2">
                        <img class="item_view_img" src="@/assets/img/home/icon_2.png" alt="">
                      </div>
                      <div class="item_b">
                        <div class="item_b_text1">政府场景｜区域能碳管控平台服务</div>
                        <div class="item_b_text2">碳知AI助力区域能碳数据汇聚、智能研判与常态化监管闭环落地</div>
                      </div>
                    </div>
                    <div class="item" @click="scrollToItem(2)">
                      <div class="item_t item_t_3"></div>
                      <div class="item_view item_view_3">
                        <img class="item_view_img" src="@/assets/img/home/icon_3.png" alt="">
                      </div>
                      <div class="item_b">
                        <div class="item_b_text1">个人场景｜Ecoself个人碳账户服务</div>
                        <div class="item_b_text2">碳知AI助力个人低碳行为记录、自动核算与碳账户闭环管理落地</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="section-3-content_2_b">
                  <template v-if="activeIndex === 0">
                    <div class="item_1">我们想核算企业碳排放，和行业做对比，了解自身碳排放现状</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img1.png" alt="">
                      <div class="item_2">已为您精准定位需求，您的诉求对应标准业务为企业组织碳盘查，可实现企业碳排放底数核算与行业对标，助力企业摸清碳排放现状、支撑合规管控与降碳优化。</div>
                    </div>
                    <div class="item_1">请按我的需求输出可落地标准化方案</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img1.png" alt="">
                      <div class="item_2">已生成专属落地碳盘查方案，规范覆盖全维度碳排放数据体系，包含企业直接用能、间接用能及供应链范围三全量数据归集，可支撑标准化碳排放核算与对标分析。</div>
                    </div>
                    <div class="item_1">是否有智能工具可快速落地方案、完成核算出报告？</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img1.png" alt="">
                      <div class="item_2">已为您智能匹配碳盘查AI Agent，完美适配本次盘查方案，支持全自动数据归集、核算对标、报告生成，点击专属链接即可直接使用。</div>
                    </div>
                    <div class="item_1">依托该工具可完成整套碳盘查工作吗？</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img1.png" alt="">
                      <div class="item_2">可实现全流程AI闭环落地。仅需填报基础数据，AI自动完成核算、对标与分析，最终输出合规标准碳盘查报告，一站式完成企业碳盘查全业务落地。</div>
                    </div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img1.png" alt="">
                      <div class="item_2 textColor" @click="gotoWeb">前往碳知体验更多 →</div>
                    </div>
                  </template>
                  <template v-else-if="activeIndex === 1">
                    <div class="item_1">我们需要统筹辖区内能耗与碳排放情况，掌握区域双碳数据，做好监管与统筹治理工作</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img2.png" alt="">
                      <div class="item_2">已为您精准定位需求，您的诉求对应标准业务为区域级能碳一体化管控，可实现辖区能耗、碳排放数据全域摸排、动态监测、态势分析，支撑政府双碳监管、政策落地与区域低碳治理。</div>
                    </div>
                    <div class="item_1">请为我生成对应的区域能碳管控落地方案</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img2.png" alt="">
                      <div class="item_2">已生成专属区域能碳管控落地方案，覆盖辖区企业用能、碳排放数据采集、台账管理、动态监测、统计分析、态势研判全流程体系，支持区域双碳指标拆解、进度追踪与治理复盘。</div>
                    </div>
                    <div class="item_1">是否有智能平台可以实现区域常态化能碳监管与数据治理？</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img2.png" alt="">
                      <div class="item_2">已为您智能匹配区域能碳管控平台，完全适配区域双碳治理方案，支持全域数据汇聚、AI智能研判、可视化大屏监测、指标统计分析，点击专属链接即可开通使用。</div>
                    </div>
                    <div class="item_1">依托该平台可完成区域双碳常态化管控工作吗？</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img2.png" alt="">
                      <div class="item_2">可实现区域能碳管控全流程AI闭环落地。平台自动汇聚辖区能碳数据、智能分析排放态势、预警异常数据，最终输出区域双碳分析报表与治理依据，一站式完成区域双碳数字化监管落地。</div>
                    </div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img2.png" alt="">
                      <div class="item_2 textColor" @click="gotoWeb">前往碳知体验更多 →</div>
                    </div>
                  </template>
                  <template v-else-if="activeIndex === 2">
                    <div class="item_1">我想记录个人低碳行为，统计自己的碳减排量，参与个人低碳生活实践</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img3.png" alt="">
                      <div class="item_2">已为您精准定位需求，您的诉求对应碳普惠场景，可实现个人日常低碳行为记录、碳足迹核算、减排量统计，助力个人量化低碳成果、参与低碳权益互动。</div>
                    </div>
                    <div class="item_1">请帮我搭建个人碳账户，系统化记录和管理个人低碳数据</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img3.png" alt="">
                      <div class="item_2">已为您生成个人碳账户运营方案，支持出行、消费、节能、办公等多场景低碳行为归集，自动核算个人碳足迹与减排额度，建立专属个人低碳数据档案，实现长效化、可视化低碳管理。</div>
                    </div>
                    <div class="item_1">有没有专属工具可以便捷记录行为、自动核算个人碳数据？</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img3.png" alt="">
                      <div class="item_2">已为您智能匹配专属产品Ecoself个人碳账户，适配个人全场景低碳数据统计需求，支持行为一键录入、AI自动核算、碳资产可视化管理，点击专属链接即可注册使用。</div>
                    </div>
                    <div class="item_1">通过Ecoself可以完整管理我的个人低碳数据吗？</div>
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img3.png" alt="">
                      <div class="item_2">可实现个人低碳管理全流程AI闭环服务。平台自动归集、核算、归档个人低碳数据，生成专属个人碳账户档案与碳足迹报告，一站式完成个人低碳量化、管理与价值沉淀。</div>
                    </div>  
                    <div class="itemOther">
                      <img class="item_img" src="@/assets/img/home/item_img3.png" alt="">
                      <div class="item_2 textColor" @click="gotoWeb">前往碳知体验更多 →</div>
                    </div>
                  </template>
                </div>
                <div class="mask"></div>
                <div class="bottomView" @click="gotoWeb">
                  <img class="bottomView_img" src="@/assets/img/home/bottomViewImg.png" alt="">
                </div>
              </div>
              <!-- <div class="section-3-content_3">
                <div class="section-3-content_3_view">
                  <img class="section-3-content_3_img1" src="@/assets/img/home/section-3-content_3_img1.png" alt="">
                  <div>
                    <div class="section-3-content_3_text1">为什么需要碳知</div>
                    <div class="section-3-content_3_text2">双碳不是“生成文本”,</div>
                    <div class="section-3-content_3_text2">双碳是专业决策。</div>
                    <div class="section-3-content_3_text3 margintop-30">传统双碳咨询，高度依赖专家经验。</div>
                    <div class="section-3-content_3_text3">周期长，成本高，难复制。</div>
                    <div class="section-3-content_3_text3">通用大模型虽然快，却容易跳过最关键的部分：政策边界、数据条件、适用对象、执行路径与责任风险。它可以生成一份看似完整的文本，却未必能承担真实双碳工作所需要的专业判断。</div>
                    <div class="section-3-content_3_text3">碳知改变的，正是这件事。它不会在信息不足时急于给出结论，而是像一位真正的双碳专家一样，先问清楚。通过专业交互，碳知会把一句模糊需求，逐步转化为一个<span>结构化、可推演、可执行的双碳问题</span>。</div>
                  </div>
                </div>
              </div> -->
              <!-- <div class="section-3-content_4">
                <img class="section-3-content_4_img1" src="@/assets/img/home/section-3-content_4_img1.png" alt="">
                <img class="section-3-content_4_img2" src="@/assets/img/home/section-3-content_4_img2.png" alt="">
              </div>
              <div class="section-3-content_5">
                <div class="section-3-content_5_view">
                  <div class="section-3-content_5_view_content">
                    <img class="section-3-content_5_view_content_img" src="@/assets/img/home/section-3-content_5_view_content_img.png" alt="">
                  </div>
                </div>
              </div>
              <div class="section-3-content_5_dask">
                <div class="section-3-content_5_dask_view">
                  <div class="section-3-content_5_dask_view_text">使用场景</div>
                  <div class="section-3-content_5_dask_view_text1">从一句话开始，</div>
                  <div class="section-3-content_5_dask_view_text1">生成一套方案。</div>
                </div>
              </div> -->
              <!-- <div class="section-3-content_5_dask_other">
                <img src="@/assets/img/home/section-3-content_5_view_dask_other_img.png" alt="">
              </div> -->
              <div class="section-3-content_6">
                <div class="section-3-content_6_view">
                  <div class="section-3-content_6_view_content">
                    <div class="text1">把复杂交给碳知。<br>把决策留给你。</div>
                    <div class="text2">无论你只有一个初步想法，还是已经有政策文件、项目材料、企业数据或汇报任务，碳知都可以从第一步开始，陪你完成一份真正专业、可信、可落地的双碳方案。</div>
                    <div class="text3" @click="gotoWeb">立即体验碳知</div>
                  </div>
                  <img class="section-3-content_6_img" src="@/assets/img/home/section-3-content_6_img.png" alt="">
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Footer from '@/components/footer/index'
import NeuralParticle from './NeuralParticle.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Footer,
    NeuralParticle
  },
  data() {
    return {
      currentIndex: 0, // 当前屏幕索引
      isScrolling: false, // 是否正在滚动中
      sections: 2, // 总屏幕数量
      transitionDuration: 1500, // 过渡动画时间（毫秒），这里改为1秒
      isSection3Scrolling: false, // 第三屏内部是否正在滚动
      section3ScrollPosition: 0, // 第三屏内部滚动位置
      isChatScrolling: false,
      isBtnActive: 1,
      section3ScrollTop: 1000,
      img1Offset: 0,
      img2Offset: 0,
      img3Offset: 0,
      containerTop: 'auto',
      containerOffset: 0, // 控制容器垂直偏移
      activeIndex: 0,
    };
  },
  mounted() {
    this.addTrackpadSupport();
    this.$emit('section-change', this.currentIndex);
  },
  watch: {
    currentIndex(newIndex) {
      this.$emit('section-change', newIndex);
    }
  },
  beforeDestroy() {
    this.removeTrackpadSupport();
  },
  methods: {
    gotoWeb() {
      this.gotoWebSite()
    },
    /**
     * 添加触摸板支持
     */
    addTrackpadSupport() {
      // 监听触摸板手势
      document.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    
    /**
     * 移除触摸板支持
     */
    removeTrackpadSupport() {
      document.removeEventListener('wheel', this.handleWheel);
    },
    /**
     * 处理鼠标滚轮和触摸板事件
     */
    handleWheel(e) {
      // 如果正在滚动中，则忽略后续滚轮事件
      if (this.isScrolling) return;

      // 如果聊天容器正在滚动，忽略全屏滚动
      if (this.isChatScrolling) return;

      // 如果在第三屏，优先处理内部滚动
      if (this.currentIndex === 1) {
        this.handleSection3Scroll(e);
        return;
      }

      // 对于非第三屏，阻止默认行为并处理全屏切换
      e.preventDefault();

      // 全屏切换逻辑
      if (e.deltaY > 0) {
        this.nextSection();
      } else {
        this.prevSection();
      }
    },

    /**
     * 处理第三屏内部滚动
     */
    /**
 * 处理第三屏内部滚动
 */
    handleSection3Scroll(e) {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const container = section3Container;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      this.isContent1Covered = scrollTop > this.coverTriggerPoint;
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 动态计算图片偏移量（根据滚动位置）
      const maxScroll = 1500; // 最大滚动距离
      const scrollProgress = scrollTop / maxScroll;
      
      // 只有在第三屏(currentIndex === 1)时才进行动画计算
      if (this.currentIndex === 1) {
        // 获取容器元素的位置信息
        const containerElement = document.querySelector('.section-3-content_2_t_view_4');
        if (containerElement) {
          const rect = containerElement.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          
          // 判断容器是否在可视区域内
          const isVisible = rect.top < windowHeight && rect.bottom > 0;
          
          if (isVisible) {
            // 容器在可视区域内，开始动画计算
            // 调整滚动进度，使动画从阈值开始
            const adjustedProgress = scrollProgress;
            
            // 图片一开始叠在一起，随滚动逐渐向上分离，分离距离随滚动进度动态变化
            // 使用二次函数增加分离距离的动态感
            // img1 (最上层，z-index 3): 向上移动
            this.img1Offset = -(250 * Math.pow(adjustedProgress, 1.5));
            // img2 (中间层，z-index 2): 向上移动更多
            this.img2Offset = -(220 * Math.pow(adjustedProgress, 1.5));
            // img3 (最下层，z-index 1): 向上移动最多，拉开更大距离
            this.img3Offset = -(5 * Math.pow(adjustedProgress, 1.5));
            
            // 根据滚动位置设置容器位置，保持在可视区域内
            const maxMoveUp = 100; // 最多向上移动100px
            const adjustedOffset = -(maxMoveUp * adjustedProgress);
            this.containerOffset = adjustedOffset;
          } else {
            // 容器不可见时，保持图片重叠
            this.img1Offset = 0;
            this.img2Offset = 0;
            this.img3Offset = 0;
            this.containerOffset = 0;
          }
        } else {
          // 如果找不到容器元素，也保持图片重叠
          this.img1Offset = 0;
          this.img2Offset = 0;
          this.img3Offset = 0;
          this.containerOffset = 0;
        }
      } else {
        // 在其他屏幕时，将所有偏移设为0（正常位置）
        this.img1Offset = 0;
        this.img2Offset = 0;
        this.img3Offset = 0;
        this.containerOffset = 0;
      }

      // 优先处理 .section-3-content_2_b 的滚动
      // const chatContainer = document.querySelector('.section-3-content_2_b');
      // if (chatContainer) {
      //   const chatScrollTop = chatContainer.scrollTop;
      //   const chatClientHeight = chatContainer.clientHeight;
      //   const chatScrollHeight = chatContainer.scrollHeight;
      //   const chatIsAtTop = chatScrollTop <= 0;
      //   const chatIsAtBottom = chatScrollTop + chatClientHeight >= chatScrollHeight;

      //   // 获取 chatContainer 在视口中的位置
      //   const chatRect = chatContainer.getBoundingClientRect();
      //   const isChatInView = chatRect.top < window.innerHeight && chatRect.bottom > 0;

      //   // 只有当 chatContainer 在视口中时才优先处理它的滚动
      //   if (isChatInView) {
      //     // 向下滚动且 chat 未到底，阻止页面滚动，让 chat 滚动
      //     if (isScrollingDown && !chatIsAtBottom) {
      //       e.preventDefault();
      //       chatContainer.scrollTop += e.deltaY;
      //       return;
      //     }
      //     // 向上滚动且 chat 未到顶，阻止页面滚动，让 chat 滚动
      //     if (!isScrollingDown && !chatIsAtTop) {
      //       e.preventDefault();
      //       chatContainer.scrollTop += e.deltaY;
      //       return;
      //     }
      //   }
      // }

      // 检查 section-3-container 是否在边界
      const isAtTop = scrollTop <= 0;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight;

      // 如果在底部且向下滚动，准备切换到下一屏
      if (isScrollingDown && isAtBottom) {
        // 检查是否还有下一屏
        if (this.currentIndex < this.sections - 1) {
          e.preventDefault();
          this.nextSection();
          return;
        }
      } 
      // 如果在顶部且向上滚动，准备切换到上一屏
      else if (!isScrollingDown && isAtTop) {
        if (this.currentIndex > 0) {
          e.preventDefault();
          this.prevSection();
          return;
        }
      }
      
      // 如果未到达边界，允许正常滚动，不阻止默认行为
      // 这样可以让section-3内部正常滚动
      return;
    },

    /**
     * 滚动到下一屏
     */
    nextSection() {
      if (this.currentIndex < this.sections - 1) {
        this.startScroll(this.currentIndex + 1);
      }
    },

    /**
     * 滚动到上一屏
     */
    prevSection() {
      if (this.currentIndex > 0) {
        this.startScroll(this.currentIndex - 1);
      }
    },

    /**
     * 点击 item 时滚动到 section-3-content_2_b 中对应的内容组
     */
    scrollToItem(index) {
      // const chatContainer = document.querySelector('.section-3-content_2_b');
      // const targetGroup = this.$refs[`itemGroup${index}`];
      // if (chatContainer && targetGroup) {
      //   // 计算目标元素相对于 chatContainer 的偏移量
      //   const targetOffsetTop = targetGroup.offsetTop;
      //   // 平滑滚动到目标位置
      //   chatContainer.scrollTo({
      //     top: targetOffsetTop,
      //     behavior: 'smooth'
      //   });
      // }
      this.activeIndex = index;
    },

    /**
     * 开始滚动动画
     */
    startScroll(index) {
      this.isScrolling = true;
      this.currentIndex = index;
      this.$emit('section-change', index);
      
      // 滚动动画结束后重置状态
      setTimeout(() => {
          this.isScrolling = false;
      }, this.transitionDuration);
    },
  }
};
</script>

<style lang="scss" scoped>
.fullpage-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.fullpage-wrapper {
  width: 100%;
  height: 100%;
  transition: transform 1.5s ease-in-out;
  will-change: transform;
}

.fullpage-section {
  width: 100%;
  height: 100vh;
}

.section-content {
 position: relative;
 width: 100%;
 height: 100%;
}

.topBT{
  width: calc(100% * 1674 / 1920);
  height: calc(100% * 360 / 1080);
  position: absolute;
  top: calc(100% * 83 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
}

.section-1_top{
  width: 820px;
  max-height: calc(100vh - 225px);
  position: absolute;
  top: calc(100vh * 370 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .section-1_top_title{
    font-weight: 400;
    font-size: 48px;
    line-height: 150%;
    text-align: center;
    color: #fff;
  }

  .section-1_top_desc{
    font-weight: 300;
    font-style: Light;
    font-size: 18px;
    line-height: 150%;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    margin-top: 20px;
  }
  
  .section-1_top_btn{
    width: 180px;
    height: 46px;
    border-radius: 100px;
    background: #fff;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .section-1_top_btn_item{
      width: 174px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      color: rgba(0, 0, 0, 1);
      cursor: pointer;
      background: linear-gradient(270deg, #95D9C1 0%, #47789E 100%);
      color: #fff;
      font-weight: 700;
      font-style: Bold;
      border-radius: 100px;
    }
  }
}

.section-1_bottom{
  height: calc(100vh * 407 / 1080);
  left: calc(100vw * 215 / 1920);
  bottom: 0;
  width: calc(100vw * 1490 / 1920);
  position: absolute;
  z-index: 5;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: self-end;

  .section-1_bottom_img{
    width: calc(100vw * 1490 / 1920);
    height: calc(100vh * 407 / 1080);
  }
}

/* 各屏背景色 */
.section-1 {
  background: linear-gradient(0deg, #CCFCEB 0%, #47789E 50%, #000000 100%);
  position: relative;

  .mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: url('../../assets/img/home/mask.png');
    background-size: cover;
  }

  .section-content_1{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    // background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
    width: 100%;
    height: 100%;
  }
}

.section-3 {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }
     
    .section-3-content{
      width: 100%;
      // background: rgba(0, 0, 0, 1);
     
      .section-3-content_1{
        width: 100%;
        background: linear-gradient(180deg, #DDF6FA 0%, #F5F5F7 100%);
        overflow: hidden;
        height: 100%;
        position: sticky;
        top: 0;
        z-index: 1;

        .section-3-content_1_view{
          // width: calc(100vw * 860 / 1920);
          // margin: calc(100vh * 165 / 1080) auto 60px;
          width: 100vw;
          height: 100vh;
          background: url(../../assets/img/home/content_1_view_back.png) no-repeat;
          background-size: cover;
          // background-position: center center;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          align-items: center;
          position: relative;

          .section-3-content_1_view_title{
            font-weight: 500;
            font-size: 22px;
            color: rgba(64, 64, 64, 1);
            margin-top: calc(100% * 250 / 1920);
            // margin-top: 165px;

            span{
              font-family: Akzidenz-Grotesk BQ Condensed;
              font-weight: 500;
              font-size: 22px;
              text-transform: uppercase;
              background: linear-gradient(270deg, #95D9C1 0%, #47789E 100%);
              -webkit-background-clip: text;
              background-clip: text;
              color: transparent;
            }
          }

          .section-3-content_1_view_desc{
            font-weight: 700;
            text-transform: uppercase;
            background: linear-gradient(270deg, #95D9C1 0%, #47789E 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            line-height: 48px;
          }

          .fontSize-48{
            font-size: 48px;
          }

          .fontSize-24{
            font-size: 24px;
          }

          .section-3-content_1_view_img{
            width: 100%;
            height: calc(100vh * 580 / 1080);
            margin-top: -108px;
          }

          .section-3-content_1_view_btn{
            width: 150px;
            height: 50px;
            border-radius: 100px;
            background: rgba(25, 140, 255, 1);
            color: #fff;
            font-weight: 300;
            font-size: 20px;
            letter-spacing: 20%;
            margin-top: calc(100% * 468 / 1920);
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .section-3-content_1_view_text{
            
            font-weight: 300;
            font-style: Light;
            font-size: 16px;
            line-height: 150%;
            color: rgba(64, 64, 64, 1);
            text-align: center;
            margin-top: 14px;
          }
        }
      }

      .section-3-content_1_dask{
        width: 100%;
        height: 100%;
        z-index: 1;
        background: rgba(255, 255, 255, 0.01);
        backdrop-filter: blur(20px);
        overflow: hidden;
        position: relative;
        z-index: 2;

        .section-3-content_1_dask_view{
          width: 1000px;
          margin: 300px auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          div{
            
            font-weight: 700;
            font-style: Bold;
            font-size: 32px;
            line-height: 150%;
            text-align: center;
            color: rgba(0, 0, 0, 1);
          }
        }
      }

      .section-3-content_2{
        width: 100%;
        // min-height: calc(100vh * 920 / 1080);
        overflow: hidden;
        // margin-top: 96px;
        background: rgba(250, 250, 250, 1);
        position: relative;
        z-index: 2;

        .section-3-content_2_t{

          .section-3-content_2_t_view{
            width: calc(100vw * 1000 / 1920);
            margin: calc(100vh * 177 / 1080) auto 0;

            .section-3-content_2_t_view_text1{
              font-weight: 700;
              font-style: Bold;
              font-size: 48px;
              line-height: 100%;
              background: linear-gradient(180deg, #47789E 0%, #CCFCEB 100%);
              -webkit-background-clip: text;
              background-clip: text;
              -webkit-text-fill-color: transparent;
              color: transparent;
            }

            .section-3-content_2_t_view_text2{
              font-weight: 400;
              font-size: 48px;
              line-height: 100%;
              margin: 20px auto;
              color: rgba(127, 127, 127, 1);
            }
          }

          .section-3-content_2_t_view_content{
            width: calc(100vw * 1000 / 1920);
            margin: 40px auto 25px;
            display: flex;
            gap: 20px;
            justify-content: space-between;

            .item{
              width: calc(100vw * 320 / 1920);
              height: 160px;
              border-radius: 24px;
              display: flex;
              position: relative;
              // background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #F9F9F9 50%);

              .item_t{
                width: 100%;
                height: 50%;
                border-radius: 24px 24px 0 0;
                z-index: 2;
                position: absolute;
                left: 0;
                top: 0;
              }

              .item_t_1{
                background: linear-gradient(90deg, #CCFCEB 0%, #47789E 100%);
              }

              .item_t_2{
                background: linear-gradient(90deg, #FCCCCC 0%, #9E9047 100%);
              }

              .item_t_3{
                background: linear-gradient(90deg, #DBCCFC 0%, #9A479E 100%);
              }

              .item_view{
                width: 50px;
                height: 50px;
                border-radius: 16px;
                margin: 15px auto 0 8px;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 9;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;

                .item_view_img{
                  width: 25px;
                  height: 25px;
                }
              }

              .item_view_1{
                background: linear-gradient(315deg, #95D9C1 0%, #47789E 100%);
              }

              .item_view_2{
                background: linear-gradient(315deg, #FCCCCC 0%, #9E9047 100%);
              }

              .item_view_3{ 
                background: linear-gradient(315deg, #DBCCFC 0%, #9A479E 100%);
              }

              .item_b{
                width: 100%;
                height: 160px;
                border-radius: 0 0 24px 24px;
                background: url(../../assets/img/home/item_back.png) no-repeat;
                background-size: cover;
                z-index: 3;
                position: absolute;
                left: 0;
                top: 0;

                .item_b_text1{
                  font-weight: 400;
                  font-size: 20px;
                  line-height: 150%;
                  margin-top: 80px;
                  margin-left: 14px;
                  color: rgba(0, 0, 0, 1);
                }

                .item_b_text2{
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 150%;
                  color: rgba(134, 134, 134, 1);
                  margin-left: 14px;
                }
              }
            }
          }
        }

        .section-3-content_2_b{
          margin: 0px auto;
          position: relative;
          width: calc(100vw * 1000 / 1920);
          height: 500px;
          display: flex;
          gap: 10px;
          align-items: center;
          flex-direction: column;
          overflow-y: auto;
          min-height: 0;
          padding-bottom: 90px;
          scrollbar-width: none;
          -ms-overflow-style: none;
          // background: #fff;
          border-radius: 0 0 40px 40px;
          
          &::-webkit-scrollbar {
            display: none;
          }

          .item_1{
            // min-height: calc(100vh * 75 / 1080);
            background: rgba(157, 242, 159, 1);
            border-radius: 16px 0 16px 16px;
            max-width: 80%;
            padding: 15px;
            font-size: 20px;
            align-self: flex-end;
            color: rgba(0, 0, 0, 1);
          }

          .itemOther{
            display: flex;
            gap: 20px;
            align-self: flex-start;

            .item_img{
              width: 60px;
              height: 60px;
            }
          }

          .item_2{
            background: rgba(238, 238, 240, 1);
            border-radius: 0 16px 16px 16px;
            max-width: 720px;
            padding: 15px;
            font-size: 20px;
            color: rgba(0, 0, 0, 1);
          }

          .textColor{
            color: rgba(0, 119, 255, 1);
            cursor: pointer;
            z-index: 11;
          }

          .item-group{
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
          }
        }

        .mask{
          background: linear-gradient(180deg, rgba(250, 250, 250, 0) 0%, #FAFAFA 30%);
          width: calc(100vw * 1000 / 1920);
          height: 125px;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          bottom: 0px;
          z-index: 10;
          border-radius: 0px 0px 40px 40px;
        }

        .bottomView{
          width: calc(100vw * 1000 / 1920);
          height: 75px;
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          bottom: 0px;
          z-index: 11;
          cursor: pointer;

          .bottomView_img{
            width: 100%;
            height: 100%;
          }
        }
      }

      .section-3-content_3{
        width: 100%;
        height: calc(100vh * 1435 / 1080);
        display: flex;
        justify-content: center;
        background: #fff;
        position: relative;
        z-index: 2;

        .section-3-content_3_view{
          width: calc(100vw * 1000 / 1920);
          margin: calc(100vh * 276 / 1080) auto  calc(100vh * 178 / 1080);

          .section-3-content_3_img1{
            width: 100%;
            height: calc(100vh * 707 / 1080);
          }

          .section-3-content_3_img2{
            width: 100%;
            height: calc(100vh * 320 / 1080);
          }

          .section-3-content_3_text1{
            
            font-weight: 700;
            font-style: Bold;
            font-size: 16px;
            line-height: 150%;
            letter-spacing: 0%;
            color: rgba(0, 0, 0, 1);
          }

          .section-3-content_3_text2{
            
            font-weight: 700;
            font-style: Bold;
            font-size: 24px;
            line-height: 150%;
            letter-spacing: 0%;
            color: rgba(0, 0, 0, 1);
          }

          .section-3-content_3_text3{
            
            font-weight: 300;
            font-style: Light;
            font-size: 16px;
            line-height: 170%;
            color: rgba(0, 0, 0, 1);

            span{
              font-weight: 700;
            }
          }

          .margintop-30{
            margin-top: 30px;
          }
        }
      }

      .section-3-content_4{
        width: 100%;
        display: flex;
        flex-direction: column;
        background: #fff;
        position: relative;
        z-index: 2;

        .section-3-content_4_img1{
          width: 100%;
          height: calc(100vh * 768 / 1080);
        }

        .section-3-content_4_img2{
          width: calc(100vw * 480 / 1920);
          height: calc(100vh * 260 / 1080);
          margin: calc(100vh * 30 / 1080) auto calc(100vh * 124 / 1080);
        }
      }

      .section-3-content_5{
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: sticky;
        top: 0;
        z-index: 2;

        .section-3-content_5_view{
          width: 100%;
          height: 100%;
          position: sticky;
          top: 0;
          overflow: hidden;
          z-index: 1;

          .section-3-content_5_view_content{
            width: 100%;
            height: 100%;

            .section-3-content_5_view_content_img{
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      
      .section-3-content_5_dask{
        width: 100%;
        height: 100vh;
        // background: rgba(255, 255, 255, 0.75);
        position: relative;
        z-index: 2;

        .section-3-content_5_dask_view{
          width: 100%;
          height: 100%;
          margin: calc(100vh * 300 / 1080) auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: rgba(255, 255, 255, 0.75);

          div{
            
            font-weight: 700;
            font-style: Bold;
            line-height: 100%;
            text-align: center;
            color: rgba(0, 0, 0, 1);
          }

          .section-3-content_5_dask_view_text{
            font-size: 32px;
            margin-bottom: 58px;
          }

          .section-3-content_5_dask_view_text1{
            font-size: 96px;
            line-height: 120%;
          }
        }
      }

      .section-3-content_5_dask_other{
        width: 100%;
        height: 100vh;
        background: rgba(255, 255, 255, 0.75);
        backdrop-filter: blur(10px);
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;

        img{
          width: calc(100vw * 1088 / 1920);
          height: calc(100vh * 480 / 1080);
        }
      }

      .section-3-content_6{
        width: 100%;
        // height: calc(100vh * 670 / 1080);
        background: rgba(250, 250, 250, 1);
        position: relative;
        z-index: 2;
        display: flex;
        padding-top: 70px;
        justify-content: center;
        align-items: center;

        .section-3-content_6_view{
          width: calc(100vw * 1200 / 1920);
          height: calc(100vh * 480 / 1080);
          background: rgba(245, 245, 247, 1);
          border-radius: 24px;
          display: flex;
          justify-content: center;
          align-items: center;

          .section-3-content_6_view_content{
            width: calc(100vw * 436 / 1920);
            gap: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .text1{
              font-weight: 700;
              font-style: Bold;
              font-size: 32px;
              line-height: 150%;
              color: rgba(0, 0, 0, 1);
            }

            .text2{
              font-weight: 400;
              font-style: Regular;
              font-size: 20px;
              line-height: 150%;
              color: rgba(0, 0, 0, 1);
            }

            .text3{
              font-weight: 400;
              font-style: Regular;
              font-size: 20px;            
              color: rgba(25, 140, 255, 1);
              cursor: pointer;
            }
          }

          .section-3-content_6_img{
            width: 547px;
            height: 360px;
          }
        }
      }
    }
  }
}
</style>